module.exports = __webpack_public_path__ + "static/media/calendar.38bfb33d.svg";